import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../common/TableHead";

interface PrecisionRecallDay {
  date: string;
  date_str: string;
  true_positives: number;
  false_positives: number;
  false_negatives: number;
  true_negatives: number;
  unclassified: number;
  total_clips: number;
  precision: number | null;
  recall: number | null;
}

export const PrecisionAndRecallTableFrontel = ({
  precisionRecallData,
}: {
  precisionRecallData: PrecisionRecallDay[];
}) => {
  return (
    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
      <Table
        sx={{ minWidth: 1000, fontFamily: "Mulish" }}
        aria-label="precision-recall-table"
        stickyHeader
      >
        <TableHeadComponent
          titlesArray={[
            "Date",
            "Clips",
            "TP",
            "FP",
            "FN",
            "TN",
            "N/A",
            "Precision",
            "Recall",
          ]}
        />
        <TableBody>
          {precisionRecallData?.map(
            (row: PrecisionRecallDay, index: number) => (
              <TableRow key={row.date || index}>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.date_str}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.total_clips}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.true_positives}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.false_positives}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.false_negatives}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.true_negatives}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.unclassified}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.precision ?? "-"}
                </TableCell>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  {row.recall ?? "-"}
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
